import React, { FC } from 'react'
import { Paper } from '@mui/material'
import InputBase from '@mui/material/InputBase'
import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'
import { SubmitHandler, useForm } from 'react-hook-form'

import { useAppDispatch } from '../../../../../hooks/useAppDispatch'
import { setTaskSearch } from '../../../../../store/reducers/schedule/tasks/actions'

const paperSx = {
	p: '2px 4px',
	display: 'flex',
	alignItems: 'center',
	width: 233,
	height: '44px',
	boxShadow: 'none',
}

interface TasksSearchFormData {
	text: string
}

const TasksHeaderSearch: FC = () => {
	const dispatch = useAppDispatch()
	const searchForm = useForm({
		mode: 'all',
		defaultValues: {
			text: '',
		},
	})

	const onSubmit: SubmitHandler<TasksSearchFormData> = data => {
		dispatch(setTaskSearch(data.text))
	}

	return (
		<Paper
			component='form'
			onSubmit={searchForm.handleSubmit(onSubmit)}
			sx={paperSx}
		>
			<InputBase
				sx={{ ml: 1, flex: 1 }}
				placeholder='Search'
				inputProps={{
					'aria-label': 'search tasks',
				}}
				{...searchForm.register('text')}
			/>

			<IconButton type='submit' sx={{ p: 2.5 }} aria-label='search tasks'>
				<SearchIcon />
			</IconButton>
		</Paper>
	)
}

export default TasksHeaderSearch
